import { initPackageDetailsGuards } from '../package-details.js';

$(document).ready(function () {
    // Guard package_details on every form, whether or not a CTA block is on the
    // page. This runs here rather than in form-cta.js because form-cta.js only
    // loads alongside the pricing/tabbed-gallery blocks, while this file loads
    // with the form itself.
    initPackageDetailsGuards();

    // The SVP form has its own handler in svp-application-form.js.
    //
    // There used to be a :not(.guide-request) clause here too, but nothing
    // renders that class — config/forms/guide-request.php sets
    // 'class' => 'base-request', so the guide form arrives as .base-request and
    // is handled here. Do NOT reinstate it: guides.js only wires the popup
    // (copying data-zoho-title into input[name="guide"]) and has no submit
    // logic, so excluding the guide form would stop it submitting entirely.
    let $forms = $('form:not(#svp-application-form)');
    if($forms.length > 0) {
        $forms.each((i,e) => {
            let $thisForm = $(e);
            let validator = new ValidateForm($thisForm, null, validationMsg, true);
            $thisForm.find('button.custom-submit').on('click', function (e) {
                e.preventDefault();
                let $form = $thisForm;
                if (validator.validate(validator.phones)) {
                    $form.find('.loading-container').addClass('show');
                    //AJAX CALL FOR FORM SUBMIT ZOHO
                    let value = $(this).closest('form').serializeArray();
                    var data = {};
                    $(value).each(function (index, obj) {
                        data[obj.name] = obj.value;
                    });
                    var requestData = {
                        data: data,
                        action: $form.attr('action')
                    }
                    data = JSON.stringify(data);
                    $.ajax({
                        type: "POST",
                        url: $form.attr('action'),
                        datatype: "application/json",
                        contentType: "application/json",
                        beforeSend: function (request) {
                            request.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'));
                        },
                        data: data,
                        success: function (response) {
                            console.log(response);
                            if (response.success) {
                                $form.find('.loading-container').addClass('success');
                                setTimeout(function () {
                                    window.location = response.redirect_url;
                                }, 2000);
                                return true;
                            }
                            //if request if made successfully then the response represent the data
        
                            $("#result").empty().append(response);
                        }
                    });
                }
            });
        });
    }
});